<template>
  <div class="box8">
    <div class="top-btn">
      <el-button :loading="listLoading" @click="debounceGetList" type="primary">刷新</el-button>
    </div>
    <div class="table">
      <el-table v-loading="listLoading" :data="tableData" style="width: 100%" :highlight-current-row="true"
                :header-cell-style="{ background: '#FCFAF8', fontSize: '16px', fontFamily: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi', fontWeight: 'normal', color: '#222222' }">
        <el-table-column label="序号" prop="id" align="center" width="58">
        </el-table-column>
        <el-table-column label="文件类型" prop="methodStr" align="center" min-width="130px">
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center" min-width="220px" >
          <template slot-scope="{row}">
            <span :style="{color:statusInfo[row.status].color}">{{ statusInfo[row.status].text }}</span>
          </template>
        </el-table-column>
        <el-table-column label="异常说明" prop="extraMsg" align="center" min-width="200px">
        </el-table-column>
        <el-table-column label="操作人" prop="operator" align="center" min-width="170px">
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center" min-width="150px">
        </el-table-column>

        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 1" @click="handleDownload(scope.row)" type="text" size="small">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <Page :total="total" :current="pageNo" show-sizer show-elevator show-total @on-change="changePage"
            @on-page-size-change="changePagesize"></Page>
    </div>
  </div>
</template>

<script>
import { Page } from 'view-design'
import { getExportList } from '@/api/export.js'
import debounce from '@/utils/debounce.js'

// 0未开始，1已完成，2执行失败，3执行中
const statusInfo = {
  0:{
    color:'black',
    text:'未开始'
  },
  1:{
    color:'blue',
    text:'已完成'
  },
  2:{
    color:'red',
    text:'执行失败'
  },
  3:{
    color:'green',
    text:'执行中'
  },
}

export default {
  name: '',
  components: { Page },
  props: {},
  data() {
    return {
      search: {},
      listLoading: false,
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      statusInfo
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getList()
  },
  methods: {
    debounceGetList(){
      debounce(()=>{
        this.getList()
      },500, true)
    },
    getList() {
      this.listLoading = true
      getExportList({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }).then(res => {
        this.tableData = res.data.list
        if (res.data.pageNo === 0) {
          this.total = 0
          this.pageNo = 1
          return;
        }
        this.total = res.data.total
        this.pageNo = res.data.pageNo
        this.pageSize = res.data.pageSize
      }).catch(_err => {
        this.tableData = []
        this.total = 0
        this.pageNo = 1
      }).finally(()=>{
        this.listLoading = false
      })
    },
    handleDownload(row){
      const link = document.createElement('a');
      link.href = row.fileUrl;  // 你要下载的文件 URL
      link.download = row.filename;  // 文件下载时的文件名
      link.target = '_blank';
      link.click();  // 模拟点击下载
    },
    changePage(value) {
      this.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.pageSize = value
      this.getList()
    }
  }
}
</script>
<style lang='less' scoped>
.box8 {
  width: 100%;

  .top-btn{
    display: flex;
    justify-content: flex-end;
    margin-right: 34px;
  }

  @media(max-width: 1200px) {
    min-width: 1000px !important;
  }

  .search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin-top: 20px;

    p {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-right: 10px;
    }

    ::placeholder {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #c1c1c1;
    }

    .inputStyle {
      box-sizing: border-box;
      width: 150px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      padding-left: 10px;
      margin-right: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
    }

    :hover {
      border-color: #57a3f3;
    }

    .searchBtn {
      width: 90px;
      height: 32px;
      background: #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      line-height: 32px;
      color: rgba(255, 255, 255, 0.8);
      // margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
      cursor: pointer;
    }
  }

  .table {
    border: 1px solid #eeeeee;
    margin-top: 30px;

    .status {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
    }

    .active {
      color: #ff4f76;
    }
  }

  .page {
    // margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/export/index.vue